module.exports = __webpack_public_path__ + "img/cainiao.9f31a54.svg";